import { i18n } from '../../../i18n/translate.js';

var getDeleteButtonConfig = function getDeleteButtonConfig(onDelete) {
  return [{
    action: onDelete,
    icon: 'trash',
    style: 'link',
    iconProps: {
      color: 'red'
    },
    className: 'btn-delete-card',
    data: {
      action: 'delete-card'
    },
    'aria-label': i18n.t('Delete card')
  }];
};

export { getDeleteButtonConfig };